import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'


export default class extends Controller {
  static targets = ["coupon", "couponMessage", "btnCoupon", "value"]

  connect() {
    this.couponPath = `${window.location.pathname}/cupom.json`;
    this.paymentPath = location.pathname;
    document.querySelector("body").addEventListener("bank-slip-opened", this.generateBankSlip.bind(this));
    document.querySelector("body").addEventListener("pix-opened", this.generatePix.bind(this));
    this.dispatchEvents();
  }

  generatePix() {
    post(`${this.paymentPath}/pix`, {
      responseType: 'json'
    }).then(response => {
      console.log(response)
    }).catch(error => {
      console.error
    })
  }

  generateBankSlip() {
    post(`${this.paymentPath}/bank_slip`, {
      responseType: 'json'
    }).then(response => {
      console.log(response)
    }).catch(error => {
      location.reload();
    })
  }

  dispatchEvents() {
    this.dispatchEvent('course');
    this.dispatchEvent('modality');
    this.dispatchEvent('pole');
    this.dispatchEvent('ingress-type');
    this.dispatchEvent('inscription');
  }

  dispatchEvent(step, action = 'active') {
    const event = new CustomEvent("stepbar:update", {
      detail: { step: step, action: action }, 
      bubbles: true 
    });
    document.querySelector('body').dispatchEvent(event);
  }

  applyCoupon (event){
    event.preventDefault();
    if( this.couponTarget.value == '') return;

    this.fetchCoupom(this.couponTarget.value).then(response => {
      if (response.length == 0) {
        this.couponMessageTarget.parentElement.classList.add('alert-danger-coupon');
        this.couponMessageTarget.parentElement.classList.remove('alert-success-coupon');
        this.couponMessageTarget.parentElement.style.display = "";
        this.couponMessageTarget.parentElement.querySelector('#success').style.display = "none";
        this.couponMessageTarget.parentElement.querySelector('#error').style.display = "";
        this.couponMessageTarget.textContent = "Cupom inválido!";
        return;
      }
      this.couponMessageTarget.parentElement.classList.remove('alert-danger-coupon');
      this.couponMessageTarget.parentElement.classList.add('alert-success-coupon');
      this.couponMessageTarget.parentElement.style.display = "";
      this.couponMessageTarget.parentElement.querySelector('#success').style.display = "";
      this.couponMessageTarget.parentElement.querySelector('#error').style.display = "none";
      this.couponMessageTarget.textContent = "O cupom está sendo aplicado...";
      this.couponMessageTarget.readonly = true;
      this.btnCouponTarget.disabled = true;
      this.btnCouponTarget.parentElement.submit();
    });
  }

  async fetchCoupom(coupon) {
    const response = await post(this.couponPath,
      {
        body: {
          code: coupon
        }
      }
    );
    return await response.json;
  }
}